<app-inner-box>
  <app-subpage-header title="Lagerbestand"></app-subpage-header>

  <app-table-header
    (reload)="onRefreshList()"
    [loading]="loading"
    >
    <app-table-search-bar
      (search)="search($event)"
      [searchValue]="currentSearch"
      ariaLabel="Produktname"
    ></app-table-search-bar>
  </app-table-header>

  @if (stores$ | async; as stores) {
    <nz-table appColumnLayout
      #tableRef
      nzShowSizeChanger
      [nzFrontPagination]="false"
      [nzLoading]="loading"
      [nzData]="data.results"
      [nzTotal]="data.info.totalResults"
      [nzPageSize]="pageSize"
      [nzPageIndex]="data.info.page || 1"
      [nzScroll]="tableScroll"
      [nzNoResult]="emptyTpl"
      [nzShowTotal]="totalTpl"
      (nzQueryParams)="onQueryParamsChange($event)"
      appKeepState
      id="lagerbestand-list-table"
      >
      <thead>
        <tr>
          <th nzColumnKey="product" nzWidth="280px">Produkt</th>
          <th nzColumnKey="ean" nzWidth="140px">EAN</th>
          @for (store of stores; track store.id) {
            <th [attr.nzColumnKey]="'store-' + store.id"
              nzWidth="180px"
              nzAlign="right"
              [attr.title]="store.value"
            >{{ store.value }}</th>
          }
          <th nzColumnKey="total" nzWidth="120px" nzAlign="right">Gesamt</th>
        </tr>
      </thead>
      <tbody>
        @for (variant of data.results; track variant.id) {
          <tr>
            <td>{{ variant.fullName || '–' }}</td>
            <td class="cell-nowrap">{{ variant.ean || '–' }}</td>
            @for (store of stores; track store.id) {
              <td nzAlign="right" class="cell-nowrap">
                {{ variant.stocks | stockByStore:store | number:'1.0-2' }}
                @if (store | isStoreMainOrBbm:false:true) {
                  <div class="lagerplatz">
                    @if (variant | mainStoreSln; as sln) {
                      <a
                        [routerLink]="['/slns']"
                        [queryParams]="{ sln: sln }"
                      >Lagerplatz: {{ sln }}</a>
                    } @else {
                      <span>Lagerplatz: –</span>
                    }
                  </div>
                }
              </td>
            }
            <td nzAlign="right" class="cell-nowrap">{{ stockTotal(variant) | number:'1.0-2' }}</td>
          </tr>
        }
      </tbody>
    </nz-table>
  }

  <ng-template #emptyTpl>
    @if (!hasSearched) {
      Bitte Suchbegriff eingeben.
    } @else {
      Keine Daten
    }
  </ng-template>
  <ng-template #totalTpl let-total let-range="range">
    {{ range[0] }}–{{ range[1] }} von {{ total }}
  </ng-template>
</app-inner-box>
